/**
 * Avatar utilities - auto-pick color and initials from a name.
 */

const AVATAR_PALETTE = [
  "#93c5fd", "#c4b5fd", "#a7f3d0", "#fcd34d", "#fda4af", "#67e8f9",
  "#d9f99d", "#e9d5ff", "#fed7aa", "#bfdbfe", "#c7d2fe", "#bbf7d0",
  "#fde68a", "#fbcfe8", "#a5f3fc", "#d1fae5",
];

/**
 * Generate a deterministic color from a string (e.g. name).
 * @param {string} str - Input string (e.g. "Jane Doe")
 * @returns {string} Hex color
 */
export const getAvatarColor = (str) => {
  if (!str || typeof str !== "string") return AVATAR_PALETTE[0];
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const idx = Math.abs(hash) % AVATAR_PALETTE.length;
  return AVATAR_PALETTE[idx];
};

/**
 * Get initials from a name (e.g. "Jane Doe" -> "JD").
 * @param {string} name - Full name
 * @param {number} maxChars - Max characters (default 2)
 * @returns {string}
 */
export const getInitials = (name, maxChars = 2) => {
  if (!name || typeof name !== "string") return "?";
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) {
    return parts[0].slice(0, maxChars).toUpperCase();
  }
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase().slice(0, maxChars);
};

/**
 * Truncate text with ellipsis.
 * @param {string} text
 * @param {number} maxLen
 * @returns {string}
 */
export const truncateText = (text, maxLen = 40) => {
  if (!text || typeof text !== "string") return "";
  return text.length <= maxLen ? text : `${text.slice(0, maxLen)}...`;
};

/**
 * Strip HTML tags and decode common entities to plain text (safe for display/truncation).
 * Use this when notification body may be HTML from the API.
 * @param {string} html
 * @returns {string}
 */
export const stripHtml = (html) => {
  if (!html || typeof html !== "string") return "";
  const tmp = document.createElement("div");
  tmp.innerHTML = html;
  return (tmp.textContent || tmp.innerText || "").trim().replace(/\s+/g, " ");
};
